import React, { useEffect, useMemo, useState, useRef, lazy } from 'react';
import { motion } from 'framer-motion';
const allImages = ['https://cdn.rawproductionsgmbh.de/caro/web/web-1.jpg', 'https://cdn.rawproductionsgmbh.de/caro/web/web-2.jpg', 'https://cdn.rawproductionsgmbh.de/caro/web/web-3.jpg', 'https://cdn.rawproductionsgmbh.de/caro/web/web-4.jpg', 'https://cdn.rawproductionsgmbh.de/caro/web/web-5.jpg', 'https://cdn.rawproductionsgmbh.de/caro/web/web-6.jpg', 'https://cdn.rawproductionsgmbh.de/caro/web/web-7.jpg', 'https://cdn.rawproductionsgmbh.de/caro/web/web-8.jpg', 'https://cdn.rawproductionsgmbh.de/caro/web/web-9.jpg', 'https://cdn.rawproductionsgmbh.de/caro/web/web-10.jpg', 'https://cdn.rawproductionsgmbh.de/caro/web/web-11.jpg', 'https://cdn.rawproductionsgmbh.de/caro/web/web-12.jpg', 'https://cdn.rawproductionsgmbh.de/caro/web/web-13.jpg', 'https://cdn.rawproductionsgmbh.de/caro/web/web-14.jpg', 'https://cdn.rawproductionsgmbh.de/caro/web/web-15.jpg', 'https://cdn.rawproductionsgmbh.de/caro/web/web-16.jpg', 'https://cdn.rawproductionsgmbh.de/caro/web/web-17.jpg'];
function getRandomImages(count: number): string[] {
  const shuffled = [...allImages].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
}
export function Gallery() {
  const images = useMemo(() => getRandomImages(5), []);
  const carouselRef = useRef<HTMLDivElement>(null);
  const [dragConstraint, setDragConstraint] = useState(0);
  useEffect(() => {
    const updateConstraint = () => {
      if (carouselRef.current) {
        const scrollWidth = carouselRef.current.scrollWidth;
        const clientWidth = carouselRef.current.clientWidth;
        setDragConstraint(-(scrollWidth - clientWidth));
      }
    };
    updateConstraint();
    window.addEventListener('resize', updateConstraint);
    return () => window.removeEventListener('resize', updateConstraint);
  }, [images]);
  return <section className="py-12 w-full overflow-hidden" data-id="element-65">
      <div className="max-w-7xl mx-auto px-4" data-id="element-66">
        {/* Draggable carousel — works with mouse and touch */}
        <motion.div ref={carouselRef} className="cursor-grab active:cursor-grabbing overflow-hidden" data-id="element-67">
          <motion.div drag="x" dragConstraints={{
          left: dragConstraint,
          right: 0
        }} dragElastic={0.1} dragTransition={{
          bounceStiffness: 300,
          bounceDamping: 30
        }} className="flex gap-4" data-id="element-68">
            {images.map((src, index) => <motion.div key={src} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex-shrink-0 w-[65vw] md:w-[calc((100%-4rem)/5)]" data-id="element-69">
                <div className="aspect-[3/4] rounded-xl overflow-hidden border border-gray-100 shadow-sm pointer-events-none select-none" data-id="element-70">
                  <img src={src} alt={`Caro Loesel Gallery ${index + 1}`} className="w-full h-full object-cover" loading="lazy" draggable={false} data-id="element-71" />
                </div>
              </motion.div>)}
          </motion.div>
        </motion.div>
      </div>
    </section>;
}